export default "__VITE_ASSET__681e312e__"